import script from "./TimeView2.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeView2.vue?vue&type=script&setup=true&lang=js"

import "./TimeView2.vue?vue&type=style&index=0&id=34e85e96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e85e96"]])

export default __exports__